import { createStyles, makeStyles } from '@hawkins/styles';
export function headingStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the root element at level 0. */
        level0: {
            fontSize: hawkins.heading.fontSize0,
            fontWeight: hawkins.heading.fontWeightRegular,
        },
        /** Class name of the root element at level 1. */
        level1: {
            fontSize: hawkins.heading.fontSize1,
            fontWeight: hawkins.heading.fontWeightRegular,
        },
        /** Class name of the root element at level 2. */
        level2: {
            fontSize: hawkins.heading.fontSize2,
            fontWeight: hawkins.heading.fontWeightRegular,
        },
        /** Class name of the root element at level 3. */
        level3: {
            fontSize: hawkins.heading.fontSize3,
            fontWeight: hawkins.heading.fontWeightRegular,
        },
        /** Class name of the root element at level 4. */
        level4: {
            fontSize: hawkins.heading.fontSize4,
            fontWeight: hawkins.heading.fontWeightRegular,
        },
        /** Class name of the root element at level 5. */
        level5: {
            fontSize: hawkins.heading.fontSize5,
            fontWeight: hawkins.heading.fontWeightRegular,
        },
        /** Class name of the root element at level 6. */
        level6: {
            fontSize: hawkins.heading.fontSize6,
            fontWeight: hawkins.heading.fontWeightBold,
        },
        /** Class name of the root element at level 7. */
        level7: {
            fontSize: hawkins.heading.fontSize7,
            fontWeight: hawkins.heading.fontWeightBold,
        },
        /** Class name of the root element at level 8. */
        level8: {
            fontSize: hawkins.heading.fontSize8,
            fontWeight: hawkins.heading.fontWeightBold,
        },
        /** Class name of the root element. */
        root: {
            color: hawkins.textColor.textColorHeadingRegular,
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            lineHeight: hawkins.heading.lineHeightRegular,
            marginBottom: 0,
            marginTop: 0,
        },
        /** Class name of the root element in the disabled color variant. */
        rootColorDisabled: {
            color: hawkins.textColor.textColorHeadingXlight,
        },
        /** Class name of the root element in the faded color variant. */
        rootColorFaded: {
            color: hawkins.textColor.textColorHeadingLight,
        },
        /** Class name of the root element in the reverse color variant. */
        rootColorReverse: {
            color: hawkins.textColor.textColorHeadingReverseRegular,
        },
    });
}
export var useHeadingStyles = makeStyles(headingStyles, { name: 'Hawkins-Heading' });
